import mixpanel from "mixpanel-browser";

import { CONFIG } from "config";
import { DEVICE_ID, USER } from "data/ss-data-store";

import { getCookie } from "./cookies";

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  if (getCookie("DoNotTrack") !== "true") {
    initMixpanel();
  }
}

function initMixpanel() {
  mixpanel.init(CONFIG.MIXPANEL_TOKEN, {
    cross_subdomain_cookie: false,
    persistence: "localStorage",
  });
  mixpanel.register({
    $device_id: DEVICE_ID,
    distinct_id: USER?.userId ?? DEVICE_ID,
  });

  // Track all link and button clicks
  const appContainer = document.querySelector("#app");
  appContainer?.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;

    if (target?.tagName === "BUTTON") {
      const button = target as HTMLButtonElement;
      const id = button.dataset.testid ?? button.innerText;
      mixpanel.track("user_click", { id, element: "button" });
    }

    if (target.tagName === "A") {
      const anchor = target as HTMLAnchorElement;
      const href = anchor.getAttribute("href");
      if (!href) return;
      const url = new URL(href, window.location.origin);
      if (url.host !== window.location.host) {
        mixpanel.track("external_link", { url: href });
      } else {
        const id = anchor.dataset.testid ?? anchor.innerText;
        mixpanel.track("user_click", { id, element: "anchor" });
      }
    }
  });

  // Track page reloads
  window.addEventListener("load", () => {
    const isReload =
      window.performance
        .getEntriesByType("navigation")
        .filter((entry: PerformanceNavigationTiming) => entry.type === "reload")
        .length > 0;

    if (isReload) {
      mixpanel.track("page_reload");
    }
  });
}

export function identifyUserMixpanel({ email, firstName, userId, lastName }) {
  mixpanel.identify(userId);
  const currentId = mixpanel.get_distinct_id();
  if (currentId !== userId) {
    mixpanel.alias(currentId, userId);
  }
  mixpanel.people.set({
    $first_name: firstName,
    $last_name: lastName,
    $email: email,
  });
}

export function trackEvent(name: string, data?: { [index: string]: unknown }) {
  mixpanel.track(name, data);
}

export function trackFNOLEvent(event) {
  if (event?.name) {
    const { name, ...rest } = event;
    mixpanel.track(name, rest);
  }
}

export function setMixpanelSuperProperties(properties) {
  mixpanel.register_once(properties);
}

export function resetAnalytics() {
  mixpanel.reset();
}

export function setMixpanelProfileProperties(properties) {
  mixpanel.people.set(properties);
}
